// @ts-check

/** @type { Partial<CabD.A.ContainerConfigs.ContainerConfig> } */
export const TwoDoorsOneFalseFrontSink =
{
  height: 36,
  depth: 24,
  width: 36,
  name: 'EmptyAssembly',
  isTopLevel: true,
  children: [
    {
      name: 'ToeKickAssembly',
      layout: 'DEPTH',
      height: 3,
      children: [
        {
          name: 'ToeKickFinishEnds',
          layout: 'WIDTH',
          children: [
            {
              width: 0.5,
              type: 'Panel',
              name: 'ToeKickAssembly--LeftPanel'
            },
            {
              name: 'ToeKickAssembly--HollowCenter'
            },
            {
              width: 0.5,
              type: 'Panel',
              name: 'ToeKickAssembly--RightPanel'
            }
          ]
        },
        {
          name: 'ToeKickAssembly--FrontPanel',
          type: 'Panel',
          depth: 0.5
        },
        {
          name: 'ToeKickAssembly--ToeKickSetBack',
          depth: 2
        }
      ]
    },
    {
      name: 'BaseAssembly',
      layout: 'DEPTH',
      children: [
        {
          name: 'BaseCarcassAssembly',
          layout: 'WIDTH',
          children: [
            {
              name: 'BaseLeftSide',
              type: 'Panel',
              width: 0.5
            },
            {
              name: 'BaseCarcassAssembly--InteriorAssembly',
              children: [
                {
                  name: 'BaseBottom',
                  height: 0.5,
                  type: 'Panel'
                },
                {
                  name: 'BaseInteriorAssembly',
                  layout: 'DEPTH',
                  children: [
                    {
                      name: 'BaseBack',
                      type: 'Panel',
                      depth: 0.5
                    },
                    {
                      name: 'BaseInterior',
                      children: [
                        {
                          name: 'Interior',
                          children: [
                            {},
                            {
                              height: 0.5,
                              type: 'Panel',
                              name: 'Shelf'
                            },

                            {}
                          ]
                        },
                        {
                          name: 'BaseTopAssembly',
                          height: 0.5,
                          layout: 'DEPTH',
                          children: [
                            {
                              name: 'BackStretcher',
                              depth: 2,
                              type: 'Panel'
                            },
                            {},
                            {
                              name: 'FrontStretcher',
                              depth: 1,
                              type: 'Panel'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'BaseRightSide',
              width: 0.5,
              type: 'Panel'
            }
          ]
        },
        {
          name: 'FrontExteriorAssembly',
          layout: 'WIDTH',
          depth: 0.5,
          children: [
            {
              name: 'LeftDoorOverlay',
              width: 0.25
            },
            {
              name: 'FrontAssembly',
              children: [
                {
                  name: 'BottomReveal',
                  height: 0.25
                },
                {
                  name: '2Doors',
                  layout: 'WIDTH',
                  children: [
                    {
                      handleOrientation: 'VERTICAL',
                      handlePosition: {
                        oX: {
                          type: 'toRight',
                          value: 3
                        },
                        oY: {
                          type: 'toTop',
                          value: 3
                        },
                        oZ: 'onSurface'
                      },
                      type: 'Door',
                      name: 'Door--DoorPanel'
                    },
                    {
                      width: 0.125
                    },
                    {
                      handleOrientation: 'VERTICAL',
                      handlePosition: {
                        oX: {
                          type: 'toLeft',
                          value: 3
                        },
                        oY: {
                          type: 'toTop',
                          value: 3
                        },
                        oZ: 'onSurface'
                      },
                      type: 'Door',
                      name: 'Door--DoorPanel'
                    }
                  ]
                },
                {
                  name: 'Reveal',
                  height: 0.25
                },
                {
                  name: '1FalseDrawer',
                  height: 6,
                  type: 'Panel',
                  panelParent: 'door'
                },
                {
                  name: 'TopReveal',
                  height: 0.25
                }
              ]
            },
            {
              name: 'RightDoorOverlay',
              width: 0.25
            }
          ]
        }
      ]
    }
  ],
  countertopMaterialName: 'marblewhite005'
};


